module.exports = __webpack_public_path__ + "web/img/img6.7ab9d236.png";